'use strict'

import userService from '@/services/user'
import Cookies from 'utils/Cookies'
import { SESSION_USER } from 'utils/constants'

const userString = Cookies.get(SESSION_USER) || localStorage.getItem(SESSION_USER)
const user = userString ? JSON.parse(userString) : null
const state = user ? { status: { loggedIn: true }, user } : { status: {}, user: null }

const actions = {
  loginRequest ({ commit }, payload) {
    commit('loginRequest', payload)
  },

  loginSuccess ({ commit }, payload) {
    commit('loginSuccess', payload)
  },

  loginFailure ({ commit }, payload) {
    commit('loginFailure', payload)
  },

  logout ({ commit }) {
    userService.logout()
    commit('logout')
  }
}

const mutations = {
  loginRequest (state, user) {
    state.status = {
      loggingIn: true
    }
    state.user = user
  },

  loginSuccess (state, user) {
    state.status = {
      loggedIn: true
    }
    state.user = user
  },

  loginFailure (state) {
    state.status = {}
    state.user = null
  },

  logout (state) {
    state.status = {}
    state.user = null
  },

  registerRequest (state, user) {
    state.status = {
      registering: true
    }
  },

  registerSuccess (state, user) {
    state.status = {}
  },

  registerFailure (state, error) {
    state.status = {}
  }
}

const Session = {
  namespaced: true,
  state,
  actions,
  mutations
}

export default Session
